<template>
    <div class="body">
<!--        <div class="nav">开始闯关</div>-->

        <div class="newheight"></div>
        <div class="mychild">
            <a @click="changeIndex(index)" :class="index==currentIndex?'cur':''" v-for="(item, index) of child" :key="item.id">{{item.author}}</a>
        </div>

        <a :href="'/question?courseId='+courseId+'&author='+((child[currentIndex] && child[currentIndex].author)||'')" class="c-but"><img src="/img/c-but.png"></a>
    </div>
</template>

<script>
    import Utils from '../../js/common/utils';
    export default {
        name: "start",
        data() {
            return {
                courseId: this.$route.query.courseId,
                child: [],//孩子列表
                currentIndex: 0,//当前选中的孩子
            };
        },
        created() {
            this.getChild()
        },
        methods: {
            getChild: function(){
                R.Ask.getChild({userId: Utils.getLocal('userId')}).then(child=>{
                    this.child = child
                })
            },
            changeIndex: function(index){
                this.currentIndex = index
            }
        }
    }
</script>

<style scoped>
    /* 页面css */
    .body {background:url(/img/kbg.jpg) center top; background-size:100%;height: 100vh;}
    .nav {height: 48px;padding-top: 20px;width: 100%;position: fixed;top: 0;text-align: center;display: flex;flex-direction: row;z-index: 9999;align-items: center;justify-content: center;font-size: 16px;line-height: 24px;margin: 0;padding: 0;font-weight: 600;}
    .newheight{ height:48px;}
    .mychild{text-align:center; padding-top:122px;}
    .mychild a{display:inline-block; height:32px; line-height:30px; font-size:15px; color:#666666; padding:0 18px; border:1px solid #c9c8c8; border-radius:100px; margin-right:5px; background:#FFF}
    .mychild a.cur{ background:#ffe315; color:#7e4600; border:1px solid #ffe315}
    .c-but{ display:block; height:48px; margin:0 auto; margin-top:60px;}
    .c-but img{ height:48px; display:block; margin:0 auto;}
</style>
